<template>
  <div id="app">
    <router-view/>
  
  </div> 
</template>

<script>
import backgroundVue from '@/components/Background.vue';
export default {
      components:{
        backgroundVue
  },
}
</script>

<style>
@import '../static/css/common.css';
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; 
} */
</style>



// WEBPACK FOOTER //
// src/App.vue